import { Tab, Tabs } from '@blueprintjs/core';
import { CommunicationType } from '../../models/communication';
import classes from './CommunicationCard.module.css';
import { AceCard } from '../AceCard';
import { SMSPanel } from './SMSPanel/SMSPanel';
import { EmailPanel } from './EmailPanel/EmailPanel';
import { CallsAndCommentsPanel } from './CallsAndCommentsPanel';
import { BankNotesPanel } from './BankNotesPanel/BankNotesPanel.tsx';
import { useContext } from 'react';
import { ApplicationContext } from '../../store/context.ts';

interface ICommunicationCard {
  marketCountry: string;
  applicationID: string;
}

export function CommunicationCard({
  marketCountry,
  applicationID,
}: ICommunicationCard) {
  return (
    <AceCard
      id={`CommunicationCard.${applicationID}`}
      title="Communication"
      noContentPadding
    >
      <CommunicationCardContent
        marketCountry={marketCountry}
        applicationID={applicationID}
      />
    </AceCard>
  );
}

function CommunicationCardContent({
  marketCountry,
  applicationID,
}: ICommunicationCard) {
  const { state, dispatch } = useContext(ApplicationContext);
  return (
    <div className={classes.card}>
      <Tabs
        selectedTabId={state.openApplications[applicationID].communicationTab}
        className={classes.tabs}
        onChange={(tabID) => {
          dispatch({
            type: 'Set communication tab',
            scope: { parentType: 'openApplications', id: applicationID },
            payload: tabID as CommunicationType,
          });
        }}
      >
        <Tab
          className={classes.tab}
          id={CommunicationType.CallsAndComments}
          title="Calls and comments"
          panel={<CallsAndCommentsPanel applicationID={applicationID} />}
        />
        <Tab
          className={classes.tab}
          id={CommunicationType.SMS}
          title={CommunicationType.SMS}
          panel={<SMSPanel applicationID={applicationID} />}
        />
        <Tab
          className={classes.tab}
          id={CommunicationType.Email}
          title={CommunicationType.Email}
          panel={<EmailPanel applicationID={applicationID} />}
        />
        <Tab
          className={classes.tab}
          id={CommunicationType.Banks}
          title={CommunicationType.Banks}
          panel={
            <BankNotesPanel
              marketCountry={marketCountry}
              applicationID={applicationID}
            />
          }
        />
      </Tabs>
    </div>
  );
}
